import { APIConfig } from 'src/config';
import { getDateTimeRange } from 'src/util/time';

import getRouteDateParams from './getRouteDateParams';

// Shared with the initial-load `prepareVariables` in `src/routes/index.jsx` so the
// retry page size can never silently diverge from the initial load page size.
export const PORTFOLIO_PROPERTY_MEMBER_LIST_PAGE_SIZE = 100;

/**
 * Builds variables for both initial loading and retry of the portfolio property list.
 * Honours `tz`, falling back to the configured timezone.
 * @param {object} props - Found-relay route props.
 * @returns {object|null} Retry variables, or null when the portfolio is missing.
 */
function buildPortfolioPropertyMemberListRetryVariables(props) {
  const uuid = props?.match?.params?.uuid;
  if (!uuid) {
    return null;
  }

  const { tz } = props?.match?.location?.query || {};
  const timeZone = tz || APIConfig().DEFAULT_TIMEZONE;
  const dateParams = getRouteDateParams(props?.match?.location);
  const { s: startTime, f: finishTime } = getDateTimeRange(dateParams, timeZone);

  return {
    uuid,
    count: PORTFOLIO_PROPERTY_MEMBER_LIST_PAGE_SIZE,
    start: startTime.toSeconds(),
    finish: finishTime.toSeconds(),
  };
}

export default buildPortfolioPropertyMemberListRetryVariables;
